import React, { useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { FileSpreadsheet, Download, Loader2 } from "lucide-react";

const ITEMS = [
  ["customers", "Firma / Müşteri Listesi", "İletişim bilgileri + toplam satış, ödeme ve bakiye"],
  ["ledger", "Cari Hareketler", "Tüm firmaların borç/alacak hareketleri ve yürüyen bakiye"],
  ["debts", "Borç Listesi", "Bize borcu olan firmalar"],
  ["credits", "Alacak Listesi", "Fazla ödeme yapmış (alacaklı) firmalar"],
  ["sales", "Satışlar", "Tüm satış kayıtları, ürünler ve vadeler"],
  ["payments", "Tahsilatlar", "Müşterilerden alınan ödemeler"],
  ["expenses", "Ödemeler / Giderler", "Yapılan ödemeler ve giderler"],
  ["income", "Gelirler", "Satış dışı gelirler"],
  ["products", "Ürün Listesi", "Stok, alış/satış fiyatları"],
  ["quotes", "Teklifler", "Teklif numarası, durum ve tutarlar"],
  ["suppliers", "Tedarikçiler", "Tedarikçi iletişim listesi"],
];

const dl = async (url, fallback) => {
  const res = await api.get(url, { responseType: "blob" });
  const name = res.headers["content-disposition"]?.match(/filename="?([^"]+)"?/)?.[1] || fallback;
  const href = URL.createObjectURL(res.data); const a = document.createElement("a"); a.href = href; a.download = name; a.click(); URL.revokeObjectURL(href);
};

export const ExportCenter = () => {
  const [busy, setBusy] = useState("");
  const go = async (key, url, fallback) => {
    setBusy(key);
    try { await dl(url, fallback); toast.success("Excel dosyası indirildi"); } catch { toast.error("İndirilemedi"); } finally { setBusy(""); }
  };
  return (
    <div className="space-y-4" data-testid="export-center">
      <Card className="p-6 border-primary/40 bg-primary/5 flex flex-wrap items-center justify-between gap-4">
        <div>
          <h3 className="font-bold text-lg flex items-center gap-2"><FileSpreadsheet size={18} /> Tüm Cari Hesapları Excel'e Aktar</h3>
          <p className="text-sm text-muted-foreground">Tek dosyada 11 sayfa: firmalar, cari hareketler, borç/alacak listeleri, satışlar, tahsilatlar, ödemeler, ürünler, teklifler, tedarikçiler</p>
        </div>
        <Button size="lg" onClick={() => go("all", "/export-all", "tum_cari_hesaplar.xlsx")} disabled={!!busy} data-testid="export-all-btn">
          {busy === "all" ? <Loader2 size={16} className="animate-spin mr-2" /> : <Download size={16} className="mr-2" />} Excel İndir
        </Button>
      </Card>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
        {ITEMS.map(([k, title, sub]) => (
          <Card key={k} className="p-4 flex items-center justify-between gap-3" data-testid={`export-card-${k}`}>
            <div className="min-w-0"><div className="font-semibold">{title}</div><div className="text-xs text-muted-foreground truncate">{sub}</div></div>
            <Button variant="outline" size="sm" onClick={() => go(k, `/export/${k}`, `${k}.xlsx`)} disabled={!!busy} data-testid={`export-btn-${k}`}>
              {busy === k ? <Loader2 size={14} className="animate-spin" /> : <Download size={14} />}
            </Button>
          </Card>
        ))}
      </div>
    </div>
  );
};
